import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import './SalesOpportunitiesAdmin.css';
import {
    Row, Col, Container
} from 'reactstrap';
import CollapseCard from '../CollapseCard/CollapseCard';
import PermissionWrapper from '../../auth/PermissionWrapper';
import SalesOpportunities from './SalesOpportunities';
import SalesOpportunitiesTypes from './SalesOpportunitiesTypes';
import SalesOpportunitiesStages from './SalesOpportunitiesStages';
import SalesOpportunitiesStatuses from './SalesOpportunitiesStatuses';
import { Prompt } from 'react-router-dom';
import CompanyContext from '../../auth/CompanyContext';
import SalesOpportunitiesTags from './SalesOpportunitiesTags';
import { buildStatusOptions } from './opportunityStatusTags';
import * as utilities from '../../utilities';

class SalesOpportunitiesAdminContainer extends Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);
        this.blankOpportunity = {
            id: 0,
            waNumber: '',
            name: '',
            date: '',
            typeID: 0,
            statusID: 0,
            stageID: 0,
            sourceID: 0,
            assigneeUserID: '',
            assigneeUserOther: '',
            salesRepUserID: '',
            salesRepUserOther: '',
            active: true,
            sec: '',
            primaryBusinessName: '',
            notes: '',
            nextSteps: '',
            contacts: [],
            contactLinkedID: '',
            opportunityAmount: '',
            maintenanceRequirementStatus: '',
            maintenanceNotes: '',
            maintenanceAcceptanceStatus: '',
            maintenanceEndDate: '',
            commissionNotes: '',
            didConvertToSale: false,
            didConvertToOpportunity: false
        }
        this.blankType = {
            id: 0,
            opportunity: '',
            description: '',
        }
        this.blankStage = {
            id: 0,
            opportunity: '',
            description: ''
        }
        this.blankSource = { ...this.blankStage };
        this.blankStatus = {
            id: 0,
            opportunity: '',
            description: '',
            hide: 0,
            tag1: '',
            tag2: '',
            tag3: ''
        }
        this.blankOpportunitiesTag = {
            id: 0,
            tag: '',
            order: 0,
            filterChecked: false,
            primaryCategory: false,
        }
        this.state = {
            opportunities: [],
            newOpportunity: { ...this.blankOpportunity },
            editOpportunity: { ...this.blankOpportunity },
            types: [],
            newType: { ...this.blankType },
            editType: { ...this.blankType },
            stages: [],
            newStage: { ...this.blankStage },
            editStage: { ...this.blankStage },
            sources: [],
            newSource: { ...this.blankSource },
            editSource: { ...this.blankSource },
            statuses: [],
            newStatus: { ...this.blankStatus },
            editStatus: { ...this.blankStatus },
            users: [],
            newOpportunitiesTag: { ...this.blankOpportunitiesTag },
            editOpportunitiesTag: { ...this.blankOpportunitiesTag },
            opportunitiesTags: [],
            opportunityCallback: null,
            unsavedChanges: false,
            opportunityCount: 0,
            salesTypes: [],
            selectedStatuses: [],
            defaultCheckboxes: {},
            supportsStatusMultipleCategories: false
        };
    }

    componentDidMount() {
        if (!this.props.showAdmin) {
            this.getSalesOpportunities();
        } else {
            this.getOpportunities();
        }
        this.getUsers();
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    getOpportunities = () => {
        fetch('/api/opportunities/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    types: results.data.filter(item => item.Type === 'type'),
                    stages: results.data.filter(item => item.Type === 'stage'),
                    sources: results.data.filter(item => item.Type === 'source'),
                    statuses: results.data.filter(item => item.Type === 'status'),
                    supportsStatusMultipleCategories: results.supportsMultipleCategories === true,
                }, () => {
                    this.getOpportunitiesTags();
                });
            });
    }

    getOpportunitiesTags = () => {
        fetch('/api/opportunitiesTags/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    opportunitiesTags: results.data
                }, () => {
                    const { salesTypes, selectedStatuses } = buildStatusOptions(
                        this.state.statuses,
                        this.state.opportunitiesTags,
                        this.props.type
                    );
                    // const typeCount = this.state.opportunities.filter(item => selectedStatuses.map(item2 => item2.ID).includes(item['Opportunity Status ID']) || selectedStatuses.map(item2 => item2.ID).includes(item['Opportunity Status ID'])).length;
                    // console.log(salesSubTags, selectedStatuses, salesTypes, typeCount)
                    let defaultCheckboxes = {}
                    salesTypes.forEach(salesType => {
                        defaultCheckboxes[`statusFilter${salesType.Tag.replace(/[^a-zA-Z0-9]/g, "")}`] = {
                            checked: salesType.FilterChecked,
                            statuses: salesType.salesTypes.map(item => item.ID)
                        }
                    })
                    // this.props.setTypesCount(typeCount);
                    this.setState({
                        salesTypes,
                        selectedStatuses,
                        defaultCheckboxes
                    })
                });
            });
    }

    getSalesOpportunities = () => {
        fetch('/api/salesOpportunities/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company,
                'X-Type': this.props.type
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    opportunities: results.data
                },() => {
                    this.getOpportunities();
                });
            });
    }

    getUsers = () => {
        // console.log('SalesOpportunitiesAdminContainer.js/getUsers()');
        fetch('/api/users/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState({
                    users: results.data
                });
            });
    }

    getContacts = (sec, edit) => {
        fetch(`/api/contacts/${this.props.user}/${sec}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState((prevState) => {
                    let obj = (edit) ? prevState.editOpportunity : prevState.newOpportunity;
                    obj.contacts = results.data//.filter(item => item.type === 'Contact')
                    return { ...prevState, [(edit ? 'editOpportunity' : 'newOpportunity')]: obj };
                });
            });
    }

    onEditOpportunity = (id) => {
        const opportunity = [...this.state.opportunities].filter(item => item.ID === id)[0];
        this.getContacts(opportunity['SEC#'], true);
        this.setState({
            editOpportunity: {
                id: id,
                waNumber: opportunity['WA Number'] || String(opportunity.ID),
                name: opportunity['Sales Opportunity Name'],
                date: opportunity['Sales Opportunity Date'],
                typeID: opportunity['Opportunity Type ID'],
                statusID: opportunity['Opportunity Status ID'],
                stageID: opportunity['Opportunity Stage ID'],
                sourceID: opportunity['Opportunity Source ID'] || 0,
                assigneeUserID: opportunity['Opportunity Assignee User ID'],
                assigneeUserOther: opportunity['Opportunity Assignee User Other'],
                salesRepUserID: opportunity['Opportunity Sales Rep User ID'],
                salesRepUserOther: opportunity['Opportunity Sales Rep User Other'],
                active: opportunity['Active'],
                sec: opportunity['SEC#'],
                primaryBusinessName: opportunity['Primary Business Name'],
                notes: opportunity['Notes'],
                nextSteps: opportunity['Next Steps'],
                contactLinkedID: opportunity['ContactLinkedID'],
                opportunityAmount: opportunity['Opportunity Amount'],
                maintenanceRequirementStatus: opportunity['MaintenanceRequirementStatus'],
                maintenanceNotes: opportunity['MaintenanceNotes'],
                maintenanceAcceptanceStatus: opportunity['MaintenanceAcceptanceStatus'],
                maintenanceEndDate: opportunity['MaintenanceEndDate'] !== '' && opportunity['MaintenanceEndDate'] != null ? String(opportunity['MaintenanceEndDate']).substring(0, 10) : null,
                commissionNotes: opportunity['CommissionNotes'],
                didConvertToSale: opportunity['DidConvertToSale'],
                didConvertToOpportunity: opportunity['DidConvertToOpportunity']
            }
        })
    }

    onEditOpportunitiesTag = (id) => {
        const opportunitiesTag = [...this.state.opportunitiesTags].filter(item => item.ID === id)[0];
        this.setState({
            editOpportunitiesTag: {
                id: id,
                tag: opportunitiesTag['Tag'],
                order: opportunitiesTag['Order'],
                filterChecked: opportunitiesTag['FilterChecked'],
                primaryCategory: opportunitiesTag['PrimaryCategory']
            }
        })
    }

    onEditType = (id) => {
        const type = [...this.state.types].filter(item => item.ID === id)[0];
        this.setState({
            editType: {
                id: id,
                opportunity: type.Opportunity,
                description: type.Description
            }
        })
    }

    onEditStage = (id) => {
        const stage = [...this.state.stages].filter(item => item.ID === id)[0];
        this.setState({
            editStage: {
                id: id,
                opportunity: stage.Opportunity,
                description: stage.Description
            }
        })
    }

    onEditSource = (id) => {
        const source = this.state.sources.find(item => item.ID === id);
        this.setState({ editSource: { id, opportunity: source.Opportunity, description: source.Description } });
    }

    onEditStatus = (id) => {
        const status = [...this.state.statuses].filter(item => item.ID === id)[0];
        this.setState({
            editStatus: {
                id: id,
                opportunity: status.Opportunity,
                description: status.Description,
                hide: status.Hide,
                tag1: status.Tag1,
                tag2: status.Tag2,
                tag3: status.Tag3,
            }
        })
    }

    onChangeOpportunity = (e, type, cb) => {
        e.persist();
        this.setState((prevState) => {
            let thisOpportunity = (type === 'edit') ? prevState.editOpportunity : prevState.newOpportunity;
            switch (e.target.type) {
                case "checkbox":
                    thisOpportunity[e.target.name] = !thisOpportunity[e.target.name];
                    break;
                default:
                    thisOpportunity[e.target.name] = e.target.value;
            }
            return (type === 'edit')
                ? {
                    editOpportunity: thisOpportunity,
                    unsavedChanges: true
                }
                : {
                    newOpportunity: thisOpportunity,
                    unsavedChanges: true
                };
        }, () => {
            if (cb != null) cb();
        });
    }

    onChangeOpportunitiesTag = (e, type, cb) => {
        e.persist();
        this.setState((prevState) => {
            let thisOpportunitiesTag = (type === 'edit') ? prevState.editOpportunitiesTag : prevState.newOpportunitiesTag;
            switch (e.target.type) {
                case "checkbox":
                    thisOpportunitiesTag[e.target.name] = !thisOpportunitiesTag[e.target.name];
                    break;
                default:
                    thisOpportunitiesTag[e.target.name] = e.target.value;
            }
            return (type === 'edit')
                ? {
                    editOpportunitiesTag: thisOpportunitiesTag,
                    unsavedChanges: true
                }
                : {
                    newOpportunitiesTag: thisOpportunitiesTag,
                    unsavedChanges: true
                };
        }, () => {
            if (cb != null) cb();
        });
    }

    onChangeType = (e, type) => {
        e.persist();
        this.setState((prevState) => {
            let thisType = (type === 'edit') ? prevState.editType : prevState.newType;
            switch (e.target.type) {
                case "checkbox":
                    thisType[e.target.name] = !thisType[e.target.name];
                    break;
                default:
                    thisType[e.target.name] = e.target.value;
            }
            return (type === 'edit')
                ? {
                    editType: thisType,
                    unsavedChanges: true
                }
                : {
                    newType: thisType,
                    unsavedChanges: true
                };
        });
    }

    onChangeStage = (e, type) => {
        e.persist();
        this.setState((prevState) => {
            let thisStage = (type === 'edit') ? prevState.editStage : prevState.newStage;
            switch (e.target.type) {
                case "checkbox":
                    thisStage[e.target.name] = !thisStage[e.target.name];
                    break;
                default:
                    thisStage[e.target.name] = e.target.value;
            }
            return (type === 'edit')
                ? {
                    editStage: thisStage,
                    unsavedChanges: true
                }
                : {
                    newStage: thisStage,
                    unsavedChanges: true
                };
        });
    }

    onChangeSource = (e, type) => {
        e.persist();
        this.setState(prevState => ({
            [type === 'edit' ? 'editSource' : 'newSource']: {
                ...prevState[type === 'edit' ? 'editSource' : 'newSource'],
                [e.target.name]: e.target.value
            },
            unsavedChanges: true
        }));
    }

    onChangeStatus = (e, type) => {
        e.persist();
        this.setState((prevState) => {
            let thisStatus = (type === 'edit') ? prevState.editStatus : prevState.newStatus;
            switch (e.target.type) {
                case "checkbox":
                    thisStatus[e.target.name] = !thisStatus[e.target.name];
                    break;
                default:
                    thisStatus[e.target.name] = e.target.value;
            }
            return (type === 'edit')
                ? {
                    editStatus: thisStatus,
                    unsavedChanges: true
                }
                : {
                    newStatus: thisStatus,
                    unsavedChanges: true
                };
        });
    }

    handleCancelAddOpportunity = () => {
        this.setState({
            newOpportunity: { ...this.blankOpportunity },
            unsavedChanges: false
        }, () => {
            if (this.state.opportunityCallback != null) {
                this.state.opportunityCallback();
            }
        })
    }

    handleCancelOpportunity = () => {
        this.setState({
            editOpportunity: { ...this.blankOpportunity },
            unsavedChanges: false
        })
    }

    handleCancelOpportunitiesTag = () => {
        this.setState({
            editOpportunitiesTag: { ...this.blankOpportunitiesTag },
            unsavedChanges: false
        })
    }

    handleCancelType = () => {
        this.setState({
            editType: { ...this.blankType },
            unsavedChanges: false
        })
    }

    handleCancelStage = () => {
        this.setState({
            editStage: { ...this.blankStage },
            unsavedChanges: false
        })
    }

    handleCancelSource = () => {
        this.setState({ editSource: { ...this.blankSource }, unsavedChanges: false });
    }

    handleCancelStatus = () => {
        this.setState({
            editStatus: { ...this.blankStatus },
            unsavedChanges: false
        })
    }

    handleEditOpportunity = () => {
        fetch('/api/salesOpportunities/' + this.state.editOpportunity.id, {
            method: 'PUT',
            body: JSON.stringify({
                name: this.state.editOpportunity.name,
                waNumber: this.state.editOpportunity.waNumber,
                date: this.state.editOpportunity.date,
                typeID: this.state.editOpportunity.typeID,
                statusID: this.state.editOpportunity.statusID,
                stageID: this.state.editOpportunity.stageID,
                sourceID: this.state.editOpportunity.sourceID,
                assigneeUserID: this.state.editOpportunity.assigneeUserID,
                assigneeUserOther: this.state.editOpportunity.assigneeUserOther,
                salesRepUserID: this.state.editOpportunity.salesRepUserID,
                salesRepUserOther: this.state.editOpportunity.salesRepUserOther,
                active: this.state.editOpportunity.active,
                sec: this.state.editOpportunity.sec,
                primaryBusinessName: this.state.editOpportunity.primaryBusinessName,
                notes: this.state.editOpportunity.notes,
                nextSteps: this.state.editOpportunity.nextSteps,
                contactLinkedID: this.state.editOpportunity.contactLinkedID,
                opportunityAmount: parseFloat(this.state.editOpportunity.opportunityAmount) > 0 ? parseFloat(this.state.editOpportunity.opportunityAmount) : null,
                maintenanceRequirementStatus: this.state.editOpportunity.maintenanceRequirementStatus,
                maintenanceNotes: this.state.editOpportunity.maintenanceNotes,
                maintenanceAcceptanceStatus: this.state.editOpportunity.maintenanceAcceptanceStatus,
                maintenanceEndDate: this.state.editOpportunity.maintenanceEndDate !== '' ? this.state.editOpportunity.maintenanceEndDate : null,
                commissionNotes: this.state.editOpportunity.commissionNotes,
                didConvertToSale: this.state.editOpportunity.didConvertToSale,
                didConvertToOpportunity: this.state.editOpportunity.didConvertToOpportunity
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editOpportunity: this.blankOpportunity,
                        unsavedChanges: false
                    }, () => this.getSalesOpportunities());
                } else {
                    utilities.addToast(results.message || 'Unable to update the opportunity or sale.', 5, 'danger');
                }
            });
    }

    handleEditOpportunitiesTag = () => {
        fetch('/api/opportunitiesTags/' + this.state.editOpportunitiesTag.id, {
            method: 'PUT',
            body: JSON.stringify({
                tag: this.state.editOpportunitiesTag.tag,
                order: this.state.editOpportunitiesTag.order,
                filterChecked: this.state.editOpportunitiesTag.filterChecked,
                primaryCategory: this.state.editOpportunitiesTag.primaryCategory
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editOpportunitiesTag: this.blankOpportunitiesTag,
                        unsavedChanges: false
                    }, () => this.getOpportunitiesTags());
                }
            });
    }

    handleEditType = () => {
        fetch('/api/opportunities/' + this.state.editType.id, {
            method: 'PUT',
            body: JSON.stringify({
                type: 'type',
                opportunity: this.state.editType.opportunity,
                description: this.state.editType.description,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editType: this.blankType,
                        unsavedChanges: false
                    }, () => this.getOpportunities());
                }
            });
    }

    handleEditStage = () => {
        fetch('/api/opportunities/' + this.state.editStage.id, {
            method: 'PUT',
            body: JSON.stringify({
                type: 'stage',
                opportunity: this.state.editStage.opportunity,
                description: this.state.editStage.description,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editStage: this.blankStage,
                        unsavedChanges: false
                    }, () => this.getOpportunities());
                }
            });
    }

    handleEditSource = () => {
        fetch('/api/opportunities/' + this.state.editSource.id, {
            method: 'PUT',
            body: JSON.stringify({
                type: 'source',
                opportunity: this.state.editSource.opportunity,
                description: this.state.editSource.description
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({ editSource: { ...this.blankSource }, unsavedChanges: false }, this.getOpportunities);
                }
            });
    }

    handleEditStatus = () => {
        fetch('/api/opportunities/' + this.state.editStatus.id, {
            method: 'PUT',
            body: JSON.stringify({
                type: 'status',
                opportunity: this.state.editStatus.opportunity,
                description: this.state.editStatus.description,
                hide: this.state.editStatus.hide,
                tag1: this.state.editStatus.tag1,
                tag2: this.state.editStatus.tag2,
                tag3: this.state.editStatus.tag3,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editStatus: this.blankStatus,
                        unsavedChanges: false
                    }, () => this.getOpportunities());
                }
            });
    }

    onDeleteOpportunity = (id) => {
        fetch('/api/salesOpportunities/' + id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.getSalesOpportunities();
                    this.setState({ unsavedChanges: false });
                }
            });
    }

    onDeleteOpportunitiesTag = (id) => {
        fetch('/api/opportunitiesTags/' + id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.getOpportunitiesTags();
                    this.setState({ unsavedChanges: false });
                }
            });
    }

    onDelete = (id) => {
        fetch('/api/opportunities/' + id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.getOpportunities();
                    this.setState({ unsavedChanges: false });
                }
            });
    }

    handleAddOpportunity = (e) => {
        fetch('/api/salesOpportunities/', {
            method: 'POST',
            body: JSON.stringify({
                name: this.state.newOpportunity.name,
                waNumber: this.state.newOpportunity.waNumber,
                date: this.state.newOpportunity.date,
                typeID: this.state.newOpportunity.typeID,
                statusID: this.state.newOpportunity.statusID,
                stageID: this.state.newOpportunity.stageID,
                sourceID: this.state.newOpportunity.sourceID,
                assigneeUserID: this.state.newOpportunity.assigneeUserID,
                assigneeUserOther: this.state.newOpportunity.assigneeUserOther,
                salesRepUserID: this.state.newOpportunity.salesRepUserID,
                salesRepUserOther: this.state.newOpportunity.salesRepUserOther,
                active: this.state.newOpportunity.active,
                sec: this.state.newOpportunity.sec,
                primaryBusinessName: this.state.newOpportunity.primaryBusinessName,
                notes: this.state.newOpportunity.notes,
                nextSteps: this.state.newOpportunity.nextSteps,
                contactLinkedID: this.state.newOpportunity.contactLinkedID,
                opportunityAmount: parseFloat(this.state.newOpportunity.opportunityAmount) > 0 ? parseFloat(this.state.newOpportunity.opportunityAmount) : null,
                maintenanceRequirementStatus: this.state.newOpportunity.maintenanceRequirementStatus,
                maintenanceNotes: this.state.newOpportunity.maintenanceNotes,
                maintenanceAcceptanceStatus: this.state.newOpportunity.maintenanceAcceptanceStatus,
                maintenanceEndDate: this.state.newOpportunity.maintenanceEndDate !== '' ? this.state.newOpportunity.maintenanceEndDate : null,
                commissionNotes: this.state.newOpportunity.commissionNotes,
                didConvertToSale: this.state.newOpportunity.didConvertToSale,
                didConvertToOpportunity: this.state.newOpportunity.didConvertToOpportunity
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        newOpportunity: this.blankOpportunity,
                        unsavedChanges: false
                    }, () => this.getSalesOpportunities());
                } else {
                    utilities.addToast(results.message || 'Unable to add the opportunity or sale.', 5, 'danger');
                }
            });
    }

    handleAddOpportunitiesTag = (e) => {
        fetch('/api/opportunitiesTags/', {
            method: 'POST',
            body: JSON.stringify({
                tag: this.state.newOpportunitiesTag.tag,
                order: this.state.newOpportunitiesTag.order,
                filterChecked: this.state.newOpportunitiesTag.filterChecked,
                primaryCategory: this.state.newOpportunitiesTag.primaryCategory
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        newOpportunitiesTag: this.blankOpportunitiesTag,
                        unsavedChanges: false
                    }, () => this.getOpportunitiesTags());
                }
            });
    }

    handleAddType = (e) => {
        fetch('/api/opportunities/', {
            method: 'POST',
            body: JSON.stringify({
                type: 'type',
                opportunity: this.state.newType.opportunity,
                description: this.state.newType.description,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        newType: this.blankType,
                        unsavedChanges: false
                    }, () => this.getOpportunities());
                }
            });
    }

    handleAddStage = (e) => {
        fetch('/api/opportunities/', {
            method: 'POST',
            body: JSON.stringify({
                type: 'stage',
                opportunity: this.state.newStage.opportunity,
                description: this.state.newStage.description,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        newStage: this.blankStage,
                        unsavedChanges: false
                    }, () => this.getOpportunities());
                }
            });
    }

    handleAddSource = () => {
        fetch('/api/opportunities/', {
            method: 'POST',
            body: JSON.stringify({
                type: 'source',
                opportunity: this.state.newSource.opportunity,
                description: this.state.newSource.description
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({ newSource: { ...this.blankSource }, unsavedChanges: false }, this.getOpportunities);
                }
            });
    }

    handleAddStatus = (e) => {
        fetch('/api/opportunities/', {
            method: 'POST',
            body: JSON.stringify({
                type: 'status',
                opportunity: this.state.newStatus.opportunity,
                description: this.state.newStatus.description,
                hide: this.state.newStatus.hide,
                tag1: this.state.newStatus.tag1,
                tag2: this.state.newStatus.tag2,
                tag3: this.state.newStatus.tag3
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        newStatus: this.blankStatus,
                        unsavedChanges: false
                    }, () => this.getOpportunities());
                }
            });
    }

    handleCallback = (cb) => {
        this.setState({
            opportunityCallback: cb
        })
    }



    render() {
        return (
            <>
                <Prompt
                    when={this.state.unsavedChanges}
                    message="You have unsaved changes, are you sure you want to leave?"
                />

                {!this.props.showAdmin && <PermissionWrapper {...this.props} allowedPermission="Show Secondary Ribbon" hidden={true}>
                    <Row>
                        <Col md={12} className='text-center'>
                            <h1>{this.props.type}</h1>
                        </Col>
                    </Row>
                </PermissionWrapper>}


                {!this.props.showAdmin && <SalesOpportunities
                    {...this.props}
                    clientToken={this.props.clientToken}
                    available_dates={this.props.available_dates}
                    opportunities={this.state.opportunities}
                    types={this.state.types}
                    stages={this.state.stages}
                    sources={this.state.sources}
                    statuses={this.state.statuses}
                    selectedStatuses={this.state.selectedStatuses}
                    opportunitiesTags={this.state.opportunitiesTags}
                    users={this.state.users}
                    newOpportunity={this.state.newOpportunity}
                    editOpportunity={this.state.editOpportunity}
                    blankOpportunity={this.blankOpportunity}
                    getContacts={this.getContacts}
                    onChange={this.onChangeOpportunity}
                    onEdit={this.onEditOpportunity}
                    onDelete={this.onDeleteOpportunity}
                    handleAdd={this.handleAddOpportunity}
                    handleEdit={this.handleEditOpportunity}
                    handleCancel={this.handleCancelOpportunity}
                    handleCancelAdd={this.handleCancelAddOpportunity}
                    handleCallback={this.handleCallback}
                    user={this.props.user}
                    setOpportunityCount={(num) => this.setState({ opportunityCount: num })}
                    salesTypes={this.state.salesTypes}
                    defaultCheckboxes={this.state.defaultCheckboxes}
                    getSalesOpportunities={this.getSalesOpportunities}
                />}
                {this.props.showAdmin && <Container fluid>
                    <CollapseCard title="Opportunities Types" open={false}>
                        <SalesOpportunitiesTypes
                            clientToken={this.props.clientToken}
                            types={this.state.types}
                            newType={this.state.newType}
                            editType={this.state.editType}
                            onChange={this.onChangeType}
                            onEdit={this.onEditType}
                            onDelete={this.onDelete}
                            handleAdd={this.handleAddType}
                            handleEdit={this.handleEditType}
                            handleCancel={this.handleCancelType}
                        />
                    </CollapseCard>
                    <CollapseCard title="Opportunities Statuses" open={false}>
                        <SalesOpportunitiesStatuses
                            clientToken={this.props.clientToken}
                            statuses={this.state.statuses}
                            newStatus={this.state.newStatus}
                            editStatus={this.state.editStatus}
                            opportunitiesTags={this.state.opportunitiesTags}
                            supportsMultipleCategories={this.state.supportsStatusMultipleCategories}
                            onChange={this.onChangeStatus}
                            onEdit={this.onEditStatus}
                            onDelete={this.onDelete}
                            handleAdd={this.handleAddStatus}
                            handleEdit={this.handleEditStatus}
                            handleCancel={this.handleCancelStatus}
                        />
                    </CollapseCard>
                    <CollapseCard title="Opportunities Tags" open={false}>
                        <SalesOpportunitiesTags
                            clientToken={this.props.clientToken}
                            opportunitiesTags={this.state.opportunitiesTags}
                            newOpportunitiesTag={this.state.newOpportunitiesTag}
                            editOpportunitiesTag={this.state.editOpportunitiesTag}
                            onChange={this.onChangeOpportunitiesTag}
                            onEdit={this.onEditOpportunitiesTag}
                            onDelete={this.onDeleteOpportunitiesTag}
                            handleAdd={this.handleAddOpportunitiesTag}
                            handleEdit={this.handleEditOpportunitiesTag}
                            handleCancel={this.handleCancelOpportunitiesTag}
                        />
                    </CollapseCard>
                    <CollapseCard title="Opportunities Stages" open={false}>
                        <SalesOpportunitiesStages
                            clientToken={this.props.clientToken}
                            stages={this.state.stages}
                            newStage={this.state.newStage}
                            editStage={this.state.editStage}
                            onChange={this.onChangeStage}
                            onEdit={this.onEditStage}
                            onDelete={this.onDelete}
                            handleAdd={this.handleAddStage}
                            handleEdit={this.handleEditStage}
                            handleCancel={this.handleCancelStage}
                        />
                    </CollapseCard>
                    <CollapseCard title="Opportunities Sources" open={false}>
                        <SalesOpportunitiesStages
                            label="Source"
                            stages={this.state.sources}
                            newStage={this.state.newSource}
                            editStage={this.state.editSource}
                            onChange={this.onChangeSource}
                            onEdit={this.onEditSource}
                            onDelete={this.onDelete}
                            handleAdd={this.handleAddSource}
                            handleEdit={this.handleEditSource}
                            handleCancel={this.handleCancelSource}
                        />
                    </CollapseCard>
                </Container>}
            </>
        );

    }
}

export default SalesOpportunitiesAdminContainer;
